export default __webpack_public_path__ + "static/media/beef.95b6ea9e.d3c138f4.svg";